// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { PageErrorWrapper, PageErrorWrapperStyles } from "@insite/content-library/Components/PageErrorWrapper";
import OrderLayout from "@store/Library/Components/Toolkit/Layout/OrderLayout";
import React, { useContext } from "react";

export interface RequestRmaPageContainerStyles {
    pageErrorWrapper?: PageErrorWrapperStyles;
}

export const requestRmaPageContainerStyles: RequestRmaPageContainerStyles = {};

const styles = requestRmaPageContainerStyles;

const RequestRmaPageContainer = ({ id }: WidgetProps) => {
    const orderDataView = useContext(OrderStateContext);

    return (
        <PageErrorWrapper
            value={orderDataView}
            badRequestMessage={siteMessage("Order_BadRequest")}
            notAuthorizedMessage={siteMessage("Order_NotAuthorized")}
            notFoundMessage={siteMessage("Order_NotFound")}
            extendedStyles={styles.pageErrorWrapper}
        >
            <OrderLayout id={id} />
        </PageErrorWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: RequestRmaPageContainer,
    definition: {
        displayName: "Page Container",
        allowedContexts: ["RequestRmaPage"],
        fieldDefinitions: [],
        group: "Return Request (RMA)",
    },
};
export default widgetModule;
